import React from "react";


const TermsPage = () => {


  return (
   <>
   <h1>Congrat's you got a website that got no terms of service.</h1>
   </>
  );
};

export default TermsPage;
